import { render, staticRenderFns } from "./Glossary.vue?vue&type=template&id=69fac724&scoped=true&lang=pug"
import script from "./Glossary.vue?vue&type=script&lang=ts"
export * from "./Glossary.vue?vue&type=script&lang=ts"
import style0 from "./Glossary.vue?vue&type=style&index=0&id=69fac724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fac724",
  null
  
)

export default component.exports